import { Translation, required } from '@ps/web-shared-components';
import React from 'react';

import { Occupation } from '@swf/account';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTWCL_Are_you_a_Politically_Exposed__ELL,
  TXTWCL_Tell_us_moreXX,
  TXTWCL_Your_Occupation
} from './RMFOccupationPEP.messages.json';

const RMFOccupationPEP = () => (
  <Container
    page={RMFOccupationPEP}
    headerProps={{
      title: <Translation {...TXTWCL_Your_Occupation} />
    }}
    pageTopTitle={<Translation {...TXTWCL_Tell_us_moreXX} />}
    pageTopSubtitle={<Translation {...TXTWCL_Are_you_a_Politically_Exposed__ELL} />}
  >
    <Occupation.PEPHIOSelection showText={false} validators={[required(null)]} />
    <CTAButton />
  </Container>
);

RMFOccupationPEP.displayName = 'RMFOccupationPEP';

export default RMFOccupationPEP;
